import Box from '../fun-js-lib/geometry/Box'
import Dot from '../fun-js-lib/geometry/Dot'
import Rect from '../fun-js-lib/geometry/Rect'

/**
 * Page signature images. Signature absence is represented as null.
 */
export class Signatures {
  /**
   * @param {ImageBase64WithDimensions | null} ncontractorSignature 
   * @param {ImageBase64WithDimensions | null} contractorSignature 
   * @param {ImageBase64WithDimensions | null} supervisorSignature 
   */
  constructor (ncontractorSignature, contractorSignature, supervisorSignature) {
    this.ncontractor = ncontractorSignature
    this.contractor = contractorSignature
    this.supervisor = supervisorSignature
  }
}

/**
 * @param {any} doc 
 * @param {Signatures} signatures 
 */
export const drawSignatures = (doc, signatures) => {
  /**
   * @param {ImageBase64WithDimensions | null} signature 
   * @param {Rect} rect 
   */
  const maybeDraw = (signature, rect) => {
    if (signature !== null) {
      drawSignature(doc, signature, rect)
    }
  }
  let rects = signatureRects()
  maybeDraw(signatures.ncontractor, rects[0])
  maybeDraw(signatures.contractor, rects[1])
  maybeDraw(signatures.supervisor, rects[2])
}

/**
 * @param {any} doc 
 * @param {ImageBase64WithDimensions} signatureImg 
 * @param {Rect} signatureRect 
 */
const drawSignature = (doc, signatureImg, signatureRect) =>
  doc.addImage(
    signatureImg.base64,
    'PNG',
    signatureRect.x,
    signatureRect.y,
    signatureRect.w,
    signatureRect.h,
    '',
    'FAST')

function signatureRects () {
  const signatureBox = new Box({ w: 30, h: 8 })
  const signatureRects = [
    new Rect({ dot: new Dot({ x: 47, y: 189 }), box: signatureBox }),
    new Rect({ dot: new Dot({ x: 160, y: 189 }), box: signatureBox }),
    new Rect({ dot: new Dot({ x: 222, y: 189 }), box: signatureBox })
  ]
  return signatureRects
}